import Loading from "../../General/Loading";
import {
  Col,
  Row,
  Card,
  Collapse,
  Container,
  CardBody,
  ProgressBar,
} from "react-bootstrap";
import styles from "./DetalledeConsumo.module.css";
import { useState, useEffect } from "react";
import {
  ConsultaConsumoDatosRest_Entrada,
  builtConsultaConsumoDatosRestInput,
  ConsultaConsumoDatosRest_Parametros,
  ConsultaConsumoDatosRest_Respuesta,
  Bolsa,
} from "../../Commons/Services/ConsultaConsumoDatosRest";
import { ConsultaWS } from "../../Commons/ServiciosBase";
import ConfirmMessage from "../..//General/ConfirmMessage";
const DetalledeConsumo = () => {
  const [status, setStatus] = useState("OK");
  const [showAlert, setShowAlert] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, isLoading] = useState(false);
  const [bolsaPrincipal, setBolsaPrincipal] = useState<Bolsa>();
  const [nombreBolsa, setNombreBolsa] = useState("");
  const [fechaVencimiento, setFechaVencimiento] = useState("");
  const [totalDatos, setTotalDatos] = useState("");
  const [datosDisponibles, setDatosDisponibles] = useState("");
  const [pctUsado, setPctUsado] = useState(0);
  const [showAlertError, setShowAlertError] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [existenBolsas, setExistenBolsas] = useState(true);

  useEffect(() => {
    isLoading(true);
    doConsultaConsumoDatosRest();
  }, []);

  const doConsultaConsumoDatosRest = async () => {
    try {
      //----------------------------------------------------------------------------------------------------------------------------
      const ConsultaConsumoDatosRestEntrada: ConsultaConsumoDatosRest_Entrada =
        builtConsultaConsumoDatosRestInput(
          `${sessionStorage.getItem("cuenta")}`,
          `${sessionStorage.getItem("MSISDN")}`,
          ""
        );
      let ConsultaConsumoDatosRestParametros =
        ConsultaConsumoDatosRest_Parametros(ConsultaConsumoDatosRestEntrada);
      let ConsultaConsumoDatosRestRespuesta: ConsultaConsumoDatosRest_Respuesta =
        await ConsultaWS(ConsultaConsumoDatosRestParametros);

        if (
        ConsultaConsumoDatosRestRespuesta.EBMHeaderResponse &&
        ConsultaConsumoDatosRestRespuesta.EBMHeaderResponse.ErrorNegocio
          .Estado == "ok" &&
        ConsultaConsumoDatosRestRespuesta.EBMHeaderResponse.ErrorTecnico
          .code === "ok" &&
        ConsultaConsumoDatosRestRespuesta.SC_INT_AS_ConsultaConsumoDatos_Salida
          .ListaBolsas.Bolsas &&
        ConsultaConsumoDatosRestRespuesta.SC_INT_AS_ConsultaConsumoDatos_Salida
          .ListaBolsas.Bolsas.length > 0 &&
        ConsultaConsumoDatosRestRespuesta.SC_INT_AS_ConsultaConsumoDatos_Salida
          .ListaBolsas.Bolsas != null &&
        typeof ConsultaConsumoDatosRestRespuesta
          .SC_INT_AS_ConsultaConsumoDatos_Salida.ListaBolsas.Bolsas !=
          "undefined"
      ) {
        setExistenBolsas(true);
        let Bolsas: Bolsa[] =
          ConsultaConsumoDatosRestRespuesta
            .SC_INT_AS_ConsultaConsumoDatos_Salida.ListaBolsas.Bolsas;

        Bolsas.map((bolsa: Bolsa, index: number) => {
          if (bolsa.Nombre_Bolsa.toLowerCase().includes("principal")) {
            setBolsaPrincipal(bolsa);
            setNombreBolsa(bolsa.Nombre_Bolsa);
            let fecha = bolsa.Fecha_Expiracion.split(" ");
            setFechaVencimiento(fecha[0]);
            setTotalDatos(bolsa.Total_Datos);
            setDatosDisponibles(bolsa.Datos_Disponibles);

            const numTotalDatos = +bolsa.Total_Datos.split(" ")[0];
            const numDatosDisponibles = +bolsa.Datos_Disponibles.split(" ")[0];
            setPctUsado(
              ((numTotalDatos - numDatosDisponibles) * 100) / numTotalDatos
            );
            isLoading(false);
          }
        });
      } else {
        setExistenBolsas(false);
        isLoading(false);
        console.error(ConsultaConsumoDatosRestRespuesta);
        showAlertocal(
          "ERROR",
          "Error al obtener datos de la respuesta del servicio"
        );
      }
      //----------------------------------------------------------------------------------------------------------------------------
    } catch (error) {
      setExistenBolsas(false);
        isLoading(false);
      console.error(error);
      showAlertocal("ERROR", "Error al ejecutar el servicio");
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
  };

  const showAlertocal = (p_estado: string, p_mensaje: string) => {
    setStatus(p_estado);
    setErrorAlertMessage(p_mensaje);
    setShowAlertError(true);
    setTimeout(() => {
      setShowAlertError(false);
    }, 3000);
  };

  return (
    <>
      <Loading isLoading={loading} />
      <ConfirmMessage status={status} message={message} showAlert={showAlert} />
      <Container fluid>
        <Row className={styles["headerRow"]}>
          <Col>
            <span className={styles["spectrum"]}>Detalle de Consumo</span>
            <p className={styles["title"]}>
              Aqui puedes visualizar el detale del consumo de tu plan contratdo
            </p>
          </Col>
        </Row>

        <Row className={styles["paqueteRow"]}>
          {existenBolsas ? (
            <Card className={styles["card"]}>
              <Card.Body className={styles[""]}>
                <p className={styles["tituloCard"]}>
                  Tu paquete{" "}
                  <span className={styles["tituloCardAzul"]}>
                    <b>Principal</b>
                  </span>
                </p>
                <p className={styles["subTituloCard"]}>
                  Vencimiento{" "}
                  <span className={styles["subTituloCardAzul"]}>
                    {fechaVencimiento}
                  </span>
                </p>
                <Card>
                  <Card.Body>
                    <p className={styles["subTituloCardInt"]}>
                      Datos incluidos
                    </p>
                    <p className={styles["tituloCardInt"]}>{totalDatos}</p>
                    <p className={styles["textoCardInt"]}>
                      Tienes <b>{datosDisponibles}</b> disponibles
                    </p>
                    <ProgressBar className={styles["barra"]} now={pctUsado} />
                  </Card.Body>
                </Card>
              </Card.Body>
            </Card>
          ) : (
            <Card className={styles["card"]}>
              <Card.Body className={styles[""]}>
                <p className={styles["tituloCard"]}>
                  No encontramos{" "}
                  <span className={styles["tituloCardAzul"]}>
                    <b> bolsas asignadas</b>
                  </span>
                </p>
              </Card.Body>
            </Card>
          )}
        </Row>
      </Container>
    </>
  );
};

export default DetalledeConsumo;
